import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';

import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';


interface WashingListState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
    previewShiftProducts: any[];

    stats: any;
    meta: any;
}

const state: WashingListState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
    previewShiftProducts: [],

    stats: null,

    meta: {}
};

export const ITEMS_LIST = 'ITEMS_LIST';
export const WASHING_SCHEMA = 'WASHING_SCHEMA';

export const actions: ActionTree<WashingListState, RootState> = {

    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(ITEMS_LIST)
                    .raw('documents.list')
                    .action({
                        columns: {
                            id: 'w.id',
                            status: 'w.status',
                            type_name: 'vwt.name',
                            detergent_name: 'vd.name',
                        },
                        from: 's:washings',
                        from_as: 'w',
                        joins:[
                            {
                                join: 's:voc_washing_types',
                                as: 'vwt',
                                on: {
                                    $eq: ['w.type_id', 'vwt.id']
                                }
                            },
                            {
                                join: 's:voc_detergents',
                                as: 'vd',
                                on: {
                                    $eq: ['w.detergent_id', 'vd.id']
                                }
                            }
                        ]
                    }),
                    vm.$q(WASHING_SCHEMA)
                        .raw('schemas.get')
                        .action({
                            id: `s:washings`
                        }),
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', {
                    documents: result.getOperation(ITEMS_LIST).getContent().documents,
                    meta: result.getOperation(ITEMS_LIST).getContent().meta,
                    schema: result.getOperation(WASHING_SCHEMA).getContent().schema,
                });
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    exportDataForListExport({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            const action: any = {}
            action.page_size = 10000
            action.page = 1

            vm.$db([
                vm.$q(ITEMS_LIST)
                    .raw('documents.list')
                    .action(action)
            ]).then(((result: ServerResult) => {
                resolve(result.getOperation(ITEMS_LIST).getContent());
            }));
        })
    },
};

export const mutations: MutationTree<WashingListState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
        state.meta = fetchEnumsFromSchema(data.schema);
    },

    UPDATE_ITEMS_LIST(state, data) {
        const _new_docs: any = {}
        data.documents.forEach((doc: any) => {
            _new_docs[doc.id] = doc;
        });
        const docs = state.documents.map((doc: any) => {
            if (_new_docs[doc.id] != undefined ) {
                doc = _new_docs[doc.id];
            }
            return doc;
        });
        state.documents = docs;
    },

    SET_STATS_DATA(state, data) {
        state.stats = data;
    },
};

const getters = {

};

export const STORE_KEY = '$_washing_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
